import { checkIsModelTrasnlated } from '@/utils/forgeUtils';

/**
 * Which level plan a point belongs on (AVA-764), for the zone plan view. A level can be drawn when it
 * has a plan image and is mapped to the 3D model; a point is on a level when its height is within the
 * level's elevations, edges included (the same test as the 360 scan index, scanIndex.findLevelIdForPosition).
 */
export const usableLevel = (level) => !!(level?.planImageUrl && level.mappingViewersPointsInfo?.isReady?.());

export const hasHeight = (level) => level.topElevation > level.bottomElevation;

export const onLevel = (level, z) => z >= level.bottomElevation && z <= level.topElevation;

/** The first drawable level whose height range holds z, or null. */
export function levelForHeight(levels, z) {
  return (levels || []).find((level) => usableLevel(level) && hasHeight(level) && onLevel(level, z)) || null;
}

/**
 * Why a level's plan cannot be opened, or null when it can. Mirrors LevelAndArea.showPlanView's checks;
 * drawing on the plan also needs its 2D↔3D mapping.
 */
export function planUnavailableReason(level, { forDrawing = true } = {}) {
  if (!level.planUrn) return 'No plan uploaded';
  if (!level.planImageUrl) return 'Old plan data, upload the plan again';
  if (forDrawing && !level.mappingViewersPointsInfo?.isReady?.()) return 'Not mapped to the 3D model';
  return null;
}

// The callback gets true when done, otherwise a progress string or false, so compare strictly.
export const isPlanTranslated = (level) => new Promise((resolve) => {
  checkIsModelTrasnlated(level.planUrn, level.apsRegion, (result) => resolve(result === true));
});
